// extracted by css-extract-rspack-plugin
export default {"card":"card-n0fq2n","emptyState":"emptyState-qL3I36","tableContainer":"tableContainer-andGmP","loader":"loader-krAhpN"};